import { LogsComponent } from './logs.component';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'logs',
    component: LogsComponent,
    data: { title: 'Home Leite - Logs' }
  },
];

export const LogsRoutes = RouterModule.forChild(routes);
